/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default function*({ payload }) {
  const user = JSON.parse(localStorage.getItem('user'))
  localStorage.setItem(
    'user',
    JSON.stringify({
      first_name: user.first_name,
      last_name: user.last_name,
      are_terms_accepted: user.are_terms_accepted,
      paypal_email: user.paypal_email,
      user_photo_url: user.user_photo_url,
      is_email_confirmed: user.is_email_confirmed,
      score: payload.score,
      rank: payload.rank,
      email: user.email,
      playlist_requirement: user.playlist_requirement,
    })
  )
  yield true
}
